<template>
  <th
    class="cxm-TableCellHead"
    :class="classes"
    :style="{ zIndex }"
  >
    <div
      v-if="isNotAction"
      class="cxm-TableCellHead-Content"
    >
      <slot />
      <IconBase
        v-if="sortable && isNotAction && isNotCheckbox"
        :name="descending ? 'ArrowDown' : 'ArrowUp'"
        class="cxm-TableCellHead-SortButton"
        color-hover="var(--track-color-bluegray-80)"
        size="24"
        :handle-click="handleSort"
      />
    </div>
    <span v-else-if="unpinAction">
      {{ $t('actions') }}
    </span>
  </th>
</template>

<script>
import IconBase from '@/packages/ui/components/Icon/Icon.vue';

export default {
  name: 'TableCellHead',
  components: { IconBase },
  props: {
    align: {
      type: String,
      default: 'left',
      validate: (value) => ['left', 'center', 'right'].includes(value),
    },
    descending: {
      type: Boolean,
      default: false,
    },
    field: {
      type: String,
      default: '',
    },
    isAction: {
      type: Boolean,
      default: false,
    },
    isCheckbox: {
      type: Boolean,
      default: false,
    },
    sortable: {
      type: Boolean,
      default: true,
    },
    sortBy: {
      type: String,
      default: '',
    },
    zIndex: {
      type: Number,
      default: null,
    },
    unpinAction: {
      type: Boolean,
      default: false,
    },
    unpinHead: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        [`-${this.align}`]: true,
        '-action': this.isAction,
        '-static': this.unpinHead,
        '-visible': this.unpinAction,
      };
    },
    isNotAction() {
      return this.isAction === false;
    },
    isNotCheckbox() {
      return this.isCheckbox === false;
    },
  },
  methods: {
    handleSort() {
      this.$emit('sort', this.field);
    },
  },
  i18n: {
    messages: {
      en_US: {
        actions: 'Actions',
      },
      es_ES: {
        actions: 'Acciones',
      },
      pt_BR: {
        actions: 'Ações',
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.cxm-TableCellHead {
  background-color: var(--track-color-white);
  border: solid var(--track-color-bluegray-20);
  border-width: var(--track-border-sm) 0;
  color: var(--track-color-bluegray-80);
  font-size: var(--track-font-size-xs);
  font-weight: var(--track-font-weight-semibold);
  height: 48px;
  line-height: var(--track-line-height-far);
  overflow: hidden;
  padding: var(--track-spacing-sm);
  padding-right: var(--track-spacing-md);
  position: sticky;
  text-align: left;
  text-overflow: ellipsis;
  top: 0;
  vertical-align: middle;
  white-space: nowrap;
  z-index: 10;

  &.-action:not(.-visible) {
    background-color: transparent;
    padding: 0;
    position: sticky;
    right: 0;
    width: 0;
  }

  &.-action.-visible {
    width: 0;
  }

  &.-static {
    position: static;
  }

  &.-left {
    text-align: left;
  }
  &.-center {
    text-align: center;
  }
  &.-right {
    text-align: right;
  }

  &:first-child {
    border-top-left-radius: var(--track-border-radius-sm);
    border-left-width: var(--track-border-sm);
  }

  &:last-child {
    border-top-right-radius: var(--track-border-radius-sm);
    border-right-width: var(--track-border-sm);
  }

  .cxm-TableContent & {
    &:first-child,
    &:last-child {
      border-left-width: 0;
      border-right-width: 0;
    }
  }
}

.cxm-TableCellHead-Content {
  align-items: center;
  display: flex;
  gap: var(--track-spacing-sm);
  justify-content: center;

  .cxm-TableCellHead.-left & {
    justify-content: flex-start;
  }
  .cxm-TableCellHead.-center & {
    justify-content: center;
  }
  .cxm-TableCellHead.-right & {
    justify-content: flex-end;
  }

  &:last-child {
    align-self: flex-end;
  }
}

.cxm-TableCellHead-SortButton {
  opacity: 0;

  .cxm-TableCellHead:hover & {
    opacity: 1;
  }
}
</style>
